export const FILTER_TYPES = {
  SINGLE_SELECT: 'singleSelect',
  MULTI_SELECT: 'multiSelect',
  RANGE: 'range',
  TOGGLE: 'toggle',
  TREE_LIST: 'treeList',
};

export const FILTER_MAP = {
  productIsOnOffer: { filterType: FILTER_TYPES.TOGGLE },
  productNewlyAdded: { filterType: FILTER_TYPES.TOGGLE },
  productCategorySlug: { filterType: FILTER_TYPES.MULTI_SELECT },
  flairs: { filterType: FILTER_TYPES.MULTI_SELECT },
  productWholesalerName: { filterType: FILTER_TYPES.MULTI_SELECT },
  productWholesalerVisible: { filterType: FILTER_TYPES.TOGGLE },
  productWholesalerCountryId: { filterType: FILTER_TYPES.MULTI_SELECT },
  productWholesalerBrandValues: { filterType: FILTER_TYPES.MULTI_SELECT },
  productWholesalerCountryCode: { filterType: FILTER_TYPES.MULTI_SELECT },
  leadTime: { filterType: FILTER_TYPES.MULTI_SELECT },
  priceRange: { filterType: FILTER_TYPES.RANGE },
  productWholesalerStoreMinOrderAmountGbp: { filterType: FILTER_TYPES.SINGLE_SELECT },
  productCollectionName: { filterType: FILTER_TYPES.SINGLE_SELECT },
  productProfitMargin: { filterType: FILTER_TYPES.SINGLE_SELECT },
  category: { filterType: FILTER_TYPES.TREE_LIST },
};

export const ALLOWED_FILTERS_IN_STORE_PAGE = [
  'productCategoryName',
  'flairs',
  'productCollectionName',
  'productProfitMargin',
];
